// SoilButtonComponent.tsx
import { useState, type FC } from "react";
import { Button, Tooltip } from "antd";
import { createPortal } from "react-dom";
import { ReactComponent as SoilLIcon } from "../../assets/images/soil-btn-layers.svg";
import { SoilLayerComponent } from "./SoilLayerComponent";
import { CloseOutlined } from "@ant-design/icons";
import { removeSoilImageLayer } from "../../maps/utils/soilData";
import type mapboxgl from "mapbox-gl";
import { useNewTrialState } from "../../pages/new-trail/hooks/NewTrialStateProvider";

interface SoilButtonProps {
  onOpen?: () => void;
  onClose?: () => void;
  onClearSelection?: () => void;
  isSelected?: boolean;
}

const SoilButtonComponent: FC<SoilButtonProps> = ({
  onOpen,
  onClose,
  onClearSelection,
  isSelected = false,
}) => {
  const [visible, setVisible] = useState<boolean>(false);

  const showDrawer = (): void => {
    setVisible(true);
    onOpen?.();
  };
  const { setSoilOperationsData } = useNewTrialState();

  const hideSoilLayerDrawer = (): void => {
    setVisible(false);
    if (onClose) {
      onClose();
    }
  };

  const closeSoilLayerDrawer = (): void => {
    hideSoilLayerDrawer();
    // Remove soil layer from map if present
    // Try to get the mapboxgl.Map instance from the global mapRef (used in parent)
    let map: mapboxgl.Map | null = null;
    if (
      globalThis &&
      (globalThis as any).mapRef &&
      typeof (globalThis as any).mapRef.getMap === "function"
    ) {
      map = (globalThis as any).mapRef.getMap();
    }
    if (map) {
      removeSoilImageLayer(map);
    }
    // Clear soil data so the effect does not re-add the layer
    setSoilOperationsData(undefined);
  };

  return (
    <div>
      <div className="corner-btn soil-analysis-btn">
        <Tooltip title="Click to see soil analysis" placement="left">
          <Button aria-label="Soil analysis" onClick={showDrawer}>
            <SoilLIcon className={isSelected ? "active" : ""} />
          </Button>
        </Tooltip>
        {(visible || isSelected) && (
          <Button
            className="close-button"
            onClick={(e) => {
              e.stopPropagation();
              closeSoilLayerDrawer();
              onClearSelection?.();
            }}
          >
            <CloseOutlined />
          </Button>
        )}
      </div>
      {visible &&
        createPortal(
          <SoilLayerComponent closeDrawer={hideSoilLayerDrawer} />,
          document.getElementById("trial-map") ?? document.body
        )}
    </div>
  );
};

export default SoilButtonComponent;
